import { useTheme } from '../../contexts/ThemeContext';

function Card({ children }: { children: React.ReactNode }) {
  const { theme } = useTheme();
  
  return (
    <div
      style={{
        background: theme.colors.bgSecondary,
        border: `1px solid ${theme.colors.border}`,
        borderRadius: '8px',
        padding: '20px',
        color: theme.colors.textPrimary,
        transition: 'all 0.3s ease'
      }}
    >
      {children}
    </div>
  )
}

export default Card
